import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useGetAllDashboardMetrics(params = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const res = await api.get(`/dashboard`, { params });
      return res.data;
    },
    queryKey: ['dashboard-metrics', params],
    enabled,
    retry: false,
    refetchOnWindowFocus: false
  });
}

function useGetDashboardKpis(params = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const res = await api.get(`/dashboard/kpis`, { params });
      return res.data;
    },
    queryKey: ['dashboard-kpis', params],
    enabled,
    retry: false,
    refetchOnWindowFocus: false
  });
}

function useGetDashboardOrderStatus(params = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const res = await api.get(`/dashboard/orders/status`, { params });
      return res.data;
    },
    queryKey: ['dashboard-order-status', params],
    enabled,
    retry: false,
    refetchOnWindowFocus: false
  });
}

function useGetDashboardSalesPerformance(params = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const res = await api.get(`/dashboard/sales/performance`, { params });
      return res.data;
    },
    queryKey: ['dashboard-sales-performance', params],
    enabled,
    retry: false,
    refetchOnWindowFocus: false
  });
}

export {
  useGetAllDashboardMetrics,
  useGetDashboardKpis,
  useGetDashboardOrderStatus,
  useGetDashboardSalesPerformance
}
